module.exports = __webpack_public_path__ + "static/image/history/pc/202406.png?50b382d3";